
/* injects from baggage-loader */

export const interview = {
    audios: {
        audio1: require('_images/interview/audios/01.mp3'),
        audio2: require('_images/interview/audios/02.mp3'),
        audio2B: require('_images/interview/audios/02-b.mp3'),
        audio3: require('_images/interview/audios/03.mp3'),
        audio4: require('_images/interview/audios/04.mp3'),
        audio5: require('_images/interview/audios/05.mp3'),
        audio6: require('_images/interview/audios/06.mp3'),
        audio7: require('_images/interview/audios/07.mp3'),
        audio8: require('_images/interview/audios/08.mp3'),
        audio8B: require('_images/interview/audios/08-b.mp3'),
    }
}



// WEBPACK FOOTER //
// ./src/app/index.const.js